<template>
  <div class="organizer-shell">
    <aside class="organizer-shell__sidebar" aria-label="Organizer">
      <div class="organizer-shell__brand">{{ $t('nav.organizerApp') }}</div>
      <nav class="organizer-shell__nav">
        <router-link
          class="organizer-shell__link"
          :to="{ name: 'Organizer' }"
          active-class="organizer-shell__link--active"
        >
          {{ $t('nav.results') }}
        </router-link>

        <div class="organizer-shell__group">
          <div class="organizer-shell__group-label">
            {{ $t('nav.registrations') }}
          </div>
          <router-link
            class="organizer-shell__link organizer-shell__link--nested"
            :to="{ name: 'RegistrationForms' }"
            active-class="organizer-shell__link--active"
          >
            {{ $t('nav.registrationForms') }}
          </router-link>
          <router-link
            class="organizer-shell__link organizer-shell__link--nested"
            :to="{ name: 'RegistrationCompetitions' }"
            active-class="organizer-shell__link--active"
          >
            {{ $t('nav.registrationCompetitions') }}
          </router-link>
          <router-link
            class="organizer-shell__link organizer-shell__link--nested"
            :to="{ name: 'RegistrationCups' }"
            active-class="organizer-shell__link--active"
          >
            {{ $t('nav.registrationCups') }}
          </router-link>
          
          <router-link
            class="organizer-shell__link organizer-shell__link--nested"
            :to="{ name: 'RegistrationEmbedScripts' }"
            active-class="organizer-shell__link--active"
          >
            {{ $t('nav.registrationEmbedScripts') }}
          </router-link>
        </div>
      </nav>
    </aside>

    <div class="organizer-shell__main">
      <header class="organizer-shell__top">
        <div class="organizer-shell__top-actions">
          <LanguageSwitcher class="organizer-shell__lang" />
          <button type="button" class="organizer-shell__logout" @click="onLogout">
            {{ $t('nav.logout') }}
          </button>
        </div>
      </header>
      <main class="organizer-shell__content">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script>
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import LanguageSwitcher from '@/components/UI/General/LanguageSwitcher.vue'

export default {
  name: 'OrganizerShell',
  components: { LanguageSwitcher },
  setup() {
    const store = useStore()
    const router = useRouter()

    const onLogout = () => {
      store.dispatch('logout')
      router.push('/')
    }

    return { onLogout }
  },
}
</script>

<style scoped>
.organizer-shell {
  display: flex;
  min-height: 100vh;
  background: var(--organizer-bg, #f5f5f4);
  color: var(--organizer-text, #1c1917);
  font-family: var(
    --organizer-font,
    'IBM Plex Sans',
    'Noto Sans',
    system-ui,
    sans-serif
  );
}

.organizer-shell__sidebar {
  width: 175px;
  flex-shrink: 0;
  background: var(--organizer-surface, #fafaf9);
  border-right: 1px solid var(--organizer-border, #e7e5e4);
  box-sizing: border-box;
}

.organizer-shell__brand {
  padding: 16px 18px;
  font-size: 15px;
  font-weight: 600;
  color: var(--organizer-text, #1c1917);
  border-bottom: 1px solid var(--organizer-border, #e7e5e4);
}

.organizer-shell__nav {
  padding: 12px 10px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.organizer-shell__group {
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid var(--organizer-border, #e7e5e4);
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.organizer-shell__group-label {
  padding: 6px 10px 8px;
  font-size: 12px;
  font-weight: 600;
  color: #57534e;
}

.organizer-shell__link {
  display: block;
  padding: 8px 12px;
  font-size: 14px;
  color: #44403c;
  text-decoration: none;
  border-radius: 8px;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.organizer-shell__link:hover {
  background: rgba(0, 0, 0, 0.04);
  color: #1c1917;
}

.organizer-shell__link--nested {
  padding-left: 18px;
  font-size: 13px;
}

.organizer-shell__link--active {
  background: #e7e5e4;
  color: #1c1917;
  font-weight: 600;
}

.organizer-shell__main {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.organizer-shell__top {
  flex-shrink: 0;
  height: 52px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  background: var(--organizer-surface-head, #ffffff);
  border-bottom: 1px solid var(--organizer-border, #e7e5e4);
}

.organizer-shell__top-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.organizer-shell__lang :deep(select),
.organizer-shell__lang :deep(button) {
  font-size: 13px;
}

.organizer-shell__logout {
  font-size: 13px;
  padding: 6px 12px;
  border-radius: 8px;
  border: 1px solid var(--organizer-border, #e7e5e4);
  background: #fafaf9;
  color: #44403c;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.organizer-shell__logout:hover {
  background: #f5f5f4;
}

.organizer-shell__content {
  flex: 1;
  min-height: 0;
  overflow: auto;
}
</style>
